const AUDIO_PLAY_EVENT = "compact-audio-play";

export const notifyAudioPlay = id => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(AUDIO_PLAY_EVENT, {
      detail: { id },
    })
  );
};

export const subscribeToAudioPlay = (id, wavesurfer) => {
  if (typeof window === "undefined") return () => {};

  const handler = event => {
    const playingId = event.detail?.id;

    if (playingId && playingId !== id && wavesurfer && wavesurfer.isPlaying()) {
      wavesurfer.pause();
    }
  };

  window.addEventListener(AUDIO_PLAY_EVENT, handler);

  return () => {
    window.removeEventListener(AUDIO_PLAY_EVENT, handler);
  };
};
